<template>
  <div ref="gannt_wrapper" class="px-1" id="gannt_wrap">
    <h3>{{title}} - {{dataGridSource}}</h3>
    <div class="flex align_center date_wrapper mb-24">
      <b-input-group size="sm">
        <b-input-group-prepend is-text>Start date</b-input-group-prepend>
        <flat-pickr
          :config="{
            allowInput: false,
            enableTime: true,
            time_24hr: true,
            formatDate: formatDate,
            hourIncrement: 2
          }"
          v-model="myChartStart"
          @on-change="setDatesToStorage($event, 'myChartStart')"
          class="form-control datepicker"
        />
      </b-input-group>
      <b-input-group class="ml-24" size="sm">
        <b-input-group-prepend is-text>End date</b-input-group-prepend>
        <flat-pickr
          :config="{
            allowInput: false,
            enableTime: true,
            time_24hr: true,
            formatDate: formatDate,
            hourIncrement: 2
          }"
          v-model="myChartEnd"
          @on-change="setDatesToStorage($event, 'myChartEnd')"
          class="form-control datepicker"
        />
      </b-input-group>
      <b-input-group class="ml-24" size="sm">
        <b-form-checkbox id="pushOnOverlap" v-model="pushOnOverlap">Push on overlap</b-form-checkbox>
      </b-input-group>
      <b-input-group size="sm">
        <b-form-radio-group
          id="ganntSimpleScale"
          v-model="scaleSize"
          :options="scaleOptions"
          name="radio-options"
          @change="setScale"
        ></b-form-radio-group>
      </b-input-group>
      <b-button
        variant="success"
        size="sm"
        v-b-tooltip.hover
        title="Add"
        class="ml-4 addNewRowButton"
        @click.stop="addRow"
      >
        <icon name="plus" />
      </b-button>
    </div>
    <g-gantt-chart
      v-if="isShowChart && !refreshGanttDiagram"
      :chart-start="myChartStart"
      :chart-end="myChartEnd"
      :push-on-overlap="pushOnOverlap"
      :theme="chartTheme"
      :scaleSize="scaleSize"
      :scaleDays="scaleDays"
      :scaleName="scaleName"
      :scaleProportion="scaleProportion"
      rowLabelWidth="200"
      @dragend-bar="stoppedDraggingBar($event)"
    >
      <g-gantt-row
        v-for="row in rowList"
        :key="row.title"
        :label="row.label"
        :bars="row.barList"
        bar-start="start_date"
        bar-end="end_date"
      >
        <template #bar-label="{bar}">
          <span>{{bar.name}}</span>
        </template>
        <template #bar-edit-button="{bar}">
          <b-button
            variant="dark"
            size="sm"
            class="barActionBtn"
            title="Edit"
            @click.stop="openDataGridModal(bar.rowId)"
          >
            <icon name="pencil" />
          </b-button>
        </template>
      </g-gantt-row>
    </g-gantt-chart>
    <h2 v-else>Please, select needed dates.</h2>
  </div>
</template>

<style>
</style>

<script>
import GGanttChart from './src/GGanttChart'
import GGanttRow from './src/GGanttRow'
import { mapState } from 'vuex'
import db from '@/services/db'
import GanttasticThemeColors from './src/GanttasticThemeColors.js'

// helpers
import utils from '@/helpers/utils'
import eventBus from '@/helpers/event-bus'

export default {
  name: 'GanntSimple',
  props: ['chartId'],
  components: {
    GGanttChart,
    GGanttRow,
  },
  data() {
    return {
      pushOnOverlapKey: 'PUSH_ON_OVERLAP',
      show: false,
      tasks: [],
      scale: '',
      toggler: false,
      title: '',
      cols: [],
      dataGridSource: '',
      storageType: '',
      // unwatch: () => {
      // },

      pushOnOverlap: false,
      myChartStart: '',
      myChartEnd: '',
      rowList: [
        {
          label: 'Row #1',
          barList: [],
        },
      ],

      draggedItemIndex: null,
      draggedItemParentName: '',
      draggedItem: '',
      scaleSize: 300,
      scaleDays: 1,
      scaleName: 'day',
      scaleProportion: 1,
      scaleOptions: [
        { text: 'Day', value: 300, scaleDays: 1, scaleName: 'day' },
        { text: 'Week', value: 600, scaleDays: 7, scaleName: 'week' },
        { text: '4 weeks', value: 1000, scaleDays: 28, scaleName: 'month' },
      ],
      refreshGanttDiagram: false,
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options',
      'fbUserModels',
      'models_dashboardModel',
      'fbWorkspaceData',
    ]),
    chartTheme() {
      return 'default'
    },
    isShowChart() {
      return this.myChartStart && this.myChartEnd
    },
  },
  methods: {
    removeFromStorage(arg) {
      let items = JSON.parse(localStorage.getItem('GanntSimpleDates'))
      delete items[arg]
      localStorage.setItem('GanntSimpleDates', JSON.stringify(items))
    },
    setDatesToStorage(event, arg) {
      let isItems = JSON.parse(localStorage.getItem('GanntSimpleDates'))
      isItems[this.chartId][arg] = this.$moment(new Date(event)).format(
        'YYYY-MM-DD HH'
      )
      localStorage.setItem('GanntSimpleDates', JSON.stringify(isItems))
    },
    setPushOnOverlap(pol) {
      let pushOnOverlap = JSON.stringify(pol)
      localStorage.setItem(this.pushOnOverlapKey, pushOnOverlap)
    },
    getPushOnOverlap() {
      return JSON.parse(localStorage.getItem(this.pushOnOverlapKey))
    },
    checkSelectedDates() {
      let isItems = localStorage.getItem('GanntSimpleDates')
      let datesObjBase = {
        myChartStart: this.$moment()
          .startOf('month')
          .format('YYYY-MM-DD HH'),
        myChartEnd: this.$moment()
          .endOf('month')
          .format('YYYY-MM-DD HH'),
      }
      let storageDates = {}
      storageDates[this.chartId] = datesObjBase
      if (isItems) {
        let parsed = JSON.parse(isItems)
        if (Object.keys(parsed).length && parsed[this.chartId]) {
          if (
            parsed[this.chartId].myChartStart.length ||
            parsed[this.chartId].myChartEnd.length
          ) {
            this.myChartStart = parsed[this.chartId].myChartStart
            this.myChartEnd = parsed[this.chartId].myChartEnd
          } else {
            parsed[this.chartId].myChartStart = this.myChartStart
            parsed[this.chartId].myChartEnd = this.myChartEnd
            localStorage.setItem('GanntSimpleDates', JSON.stringify(parsed))
          }
        } else {
          let item = JSON.parse(isItems)
          Object.assign(item, storageDates)
          localStorage.setItem('GanntSimpleDates', JSON.stringify(item))
        }
      } else {
        this.myChartStart = storageDates[this.chartId].myChartStart
        this.myChartEnd = storageDates[this.chartId].myChartEnd
        localStorage.setItem('GanntSimpleDates', JSON.stringify(storageDates))
      }
    },
    setScale(arg) {
      let baseScaleSize = 300
      let neededScale = this.scaleOptions.find(elem => elem.value == arg)
      this.scaleSize = neededScale.value
      this.scaleDays = neededScale.scaleDays
      this.scaleName = neededScale.scaleName
      this.scaleProportion = neededScale.value / baseScaleSize

      this.refreshGanttDiagram = true

      this.$nextTick(() => {
        this.refreshGanttDiagram = false
      })

      /*        if(this.scaleName === 'week') {
            this.myChartEnd = moment(this.myChartStart).add(7, 'days').toISOString()
        } else if(
            this.scaleName === 'month'
        ) {
            this.myChartEnd = moment(this.myChartStart).add(28, 'days').toISOString()
        }*/
    },
    openDataGridModal(rowKey) {
      $dgShowEditRowModal(this.dataGridSource, rowKey)
    },
    addRow() {
      return $dgAddRow(this.dataGridSource)
        .then(async rowKey => {
          $dgShowEditRowModal(this.dataGridSource, rowKey)
        })
        .catch(e => {
          console.error(e)
        })
    },
    stoppedDraggingBar(event) {
      let data = {
        start_date: event.bar.start_date,
        end_date: event.bar.end_date,
      }
      db.dataGrid.data.getOptions(this.dataGridSource).then(options => {
        event.movedBars.forEach(elem => {
          for (let item in data) {
            const data = {
              options,
              rowKey: elem.rowId,
              cellKey: this.cols[item],
              value: this.$moment(elem[item]).format('YYYY-MM-DD HH:mm'),
            }
            db.dataGrid.data.saveCellVal(data)
          }
        })
      })
    },
    formatDate: utils.formatDate,
    parseTasks(data) {
      this.rowList = []
      const tasks = []
      data.forEach((item, index) => {
        let isPresent = tasks.findIndex(e => e.label == item.assignedTo)
        let itemToPush = {
          label: item.assignedTo,
          barList: [
            {
              name: item.name,
              ganttBarConfig: {
                handles: true,
                class: item.color,
                borderRadius: 80,
              },
              start_date: this.$moment(item.start_date).format(
                'YYYY-MM-DD HH:mm'
              ),
              end_date: this.$moment(item.end_date).format('YYYY-MM-DD HH:mm'),
              rowId: item.rowId,
            },
          ],
        }
        if (isPresent != -1) {
          tasks[isPresent].barList.push(itemToPush.barList[0])
        } else {
          tasks.push(itemToPush)
        }
      })
      if (tasks.length) {
        this.rowList = tasks
      }
    },
    mapData(data, cols) {
      const rows = Object.keys(data)
      return Object.values(data).map((el, idx) => {
        return {
          name: el[cols.name],
          start_date: el[cols.start_date],
          end_date: el[cols.end_date],
          assignedTo:
            typeof el[`$${cols.assignedTo}$display`] !== 'undefined'
              ? el[`$${cols.assignedTo}$display`]
              : cols.assignedTo,
          rowId: rows[idx],
          color: el[cols.color.value],
        }
      })
    },
    editOptions() {
      this.show = true
      this.$nextTick(() => {
        this.$refs.editModal.open()
      })
    },
    optionsUpdate(options) {
      this.options = options
    },
    initialize() {
      this.pushOnOverlap = this.getPushOnOverlap()
      this.toggler = !this.toggler
      let dataGrid
      let columns

      db.gantt_simple.readOptions(this.chartId, value => {
        this.cols = value
        dataGrid = value.dataSource
        this.dataGridSource = dataGrid
        this.title = value.title
      })
      if (dataGrid) {
        db.dataGrid.data
          .getOptions(dataGrid)
          .then(res => {
            const getModel = db.dataGrid.data.getReadModel(res.storageType)
            const data = getModel(res.source)
            if (data && Object.values(data).length) {
              const mappedData = this.mapData(data, this.cols)
              this.parseTasks(mappedData)
            }
          })
          .catch(err => console.error(err))
      }
    },
  },
  watch: {
    pushOnOverlap: function(val) {
      this.setPushOnOverlap(val)
    },
  },
  mounted() {
    this.initialize()
    this.checkSelectedDates()
    eventBus.$on('editRowFormClosed', () => {
      this.initialize()
    })

    eventBus.$on('removeWidget_eventBus', dependency => {
      let formatted = dependency.split('/')[1]
      this.removeFromStorage(formatted)
    })

    let dragWrapId = '#gannt_wrap'

    /* events fired on the draggable target */
    document
      .querySelector(dragWrapId)
      .addEventListener('drag', function(event) {}, false)

    document.querySelector(dragWrapId).addEventListener(
      'dragstart',
      event => {
        // store a ref. on the dragged elem
        this.rowList.forEach(elem => {
          elem.barList.forEach((el, index) => {
            if (el.name == event.target.innerText) {
              this.draggedItemParentName = elem.label
              this.draggedItemIndex = index
              this.draggedItem = el
            }
          })
        })
        // make it half transparent
        event.target.style.opacity = 0.5
      },
      false
    )

    document.querySelector(dragWrapId).addEventListener(
      'dragend',
      function(event) {
        // reset the transparency
        event.target.style.opacity = ''
      },
      false
    )

    /* events fired on the drop targets */
    document.querySelector(dragWrapId).addEventListener(
      'dragover',
      function(event) {
        // prevent default to allow drop
        event.preventDefault()
      },
      false
    )

    document.querySelector(dragWrapId).addEventListener(
      'dragenter',
      event => {
        // highlight potential drop target when the draggable element enters it
        if (event.target.className == 'g-gantt-row-bars-container') {
          event.target.style.background =
            GanttasticThemeColors[this.chartTheme].hoverHighlight
        }
      },
      false
    )

    document.querySelector(dragWrapId).addEventListener(
      'dragleave',
      function(event) {
        // reset background of potential drop target when the draggable element leaves it
        if (event.target.className == 'g-gantt-row-bars-container') {
          event.target.style.background = ''
        }
      },
      false
    )

    document.querySelector(dragWrapId).addEventListener(
      'drop',
      event => {
        // prevent default action (open as link for some elements)
        event.preventDefault()
        // move dragged elem to the selected drop target
        if (event.target.className == 'g-gantt-row-bars-container') {
          this.rowList.forEach(elem => {
            if (elem.label == this.draggedItemParentName) {
              elem.barList.splice(this.draggedItemIndex, 1)
            }
            if (
              !event.path[1].__vue__.bars.find(
                el => el.name == this.draggedItem.name
              )
            ) {
              event.path[1].__vue__.bars.push(this.draggedItem)
              db.dataGrid.data.getOptions(this.dataGridSource).then(options => {
                const data = {
                  options,
                  rowKey: this.draggedItem.rowId,
                  cellKey: this.cols['assignedTo'],
                  value: event.path[1].__vue__.label,
                }
                db.dataGrid.data.saveCellVal(data)
              })
            }
          })
          event.target.style.background = ''
        }
      },
      false
    )
  },
}
</script>
<style lang="scss">
#gannt_wrap {
  .datepicker {
    background: transparent;
  }
}
.flex {
  display: flex;
}
.align_center {
  align-items: center;
}
.ml-24 {
  margin-left: 24px;
}
.ml-8 {
  margin-left: 8px !important;
}
.mb-24 {
  margin-bottom: 24px;
}
.input-group-text {
  background-color: #5e72e4 !important;
  color: #fff;
}
.btn {
  &.addNewRowButton {
    position: absolute;
    top: 15px;
    right: 0;
  }
  &.barActionBtn {
    width: 0;
    opacity: 0;
    transition: all ease 0.1s;
    padding: 0;
    svg {
      display: none;
    }
  }
}
.g-gantt-bar-handle-left,
.g-gantt-bar-handle-right {
  // display: none;
  transition: all ease 0.2s;
  svg {
    transition: all ease 0.2s;
    opacity: 0;
  }
}
.g-gantt-bar {
  &:hover {
    .btn {
      &.barActionBtn {
        width: auto;
        opacity: 1;
        padding: 0.15rem 0.3rem;
        svg {
          display: inline;
        }
      }
    }
    .g-gantt-bar-handle-left,
    .g-gantt-bar-handle-right {
      svg {
        opacity: 1;
      }
    }
  }
}
</style>
